import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { useTheme } from 'styled-components';
import { Modal } from '.';
import { Button } from '../../Controls/Button';
import Icons from '../../Elements/Icons';
import { Header, Wrapper } from './styled';
const StyledModal = styled(Modal) `
  min-height: 150px;
`;
const StyledHeader = styled(Header) `
  padding: 16px 16px 0;
  height: auto;

  && {
    border: 0;
  }
`;
export const ModalPlain = ({ children, ...props }) => {
    const theme = useTheme();
    return (_jsx(StyledModal, { width: '400px', height: 'auto', shouldCloseOnOverlayClick: true, ...props, children: _jsxs(Wrapper, { "data-test": 'modal-window', children: [_jsxs(StyledHeader, { children: [_jsx("div", {}), _jsx(Button, { ghost: true, iconOnly: true, onClick: props.state.close, "data-testid": 'close-button-modal-window', children: _jsx(Icons.Close, { size: 24, color: theme.colors.grey100_1 }) })] }), children] }) }));
};
